var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    rx: 12,
    fill: "#2A313C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.86 35.1464C26.0152 35.2929 26.2207 35.3743 26.4342 35.3739C26.6468 35.3757 26.8508 35.2894 26.9975 35.1355C27.1524 34.9846 27.2397 34.7776 27.2397 34.5614C27.2397 34.3451 27.1524 34.1381 26.9975 33.9872L20.8224 27.8121H35.1444C35.5931 27.8121 35.9569 27.4484 35.9569 26.9996C35.9569 26.5509 35.5931 26.1871 35.1444 26.1871H20.8201L27.0083 19.9797C27.1632 19.8288 27.2505 19.6218 27.2505 19.4055C27.2505 19.1893 27.1632 18.9823 27.0083 18.8314C26.6911 18.5145 26.1772 18.5145 25.86 18.8314L18.2767 26.4147C17.9599 26.7319 17.9599 27.2458 18.2767 27.563L25.86 35.1464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.98ad21f2b113c427700f005d3c1d6200.svg";
export { ForwardRef as ReactComponent };